import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import Contract from "slotworks/utils/contracts/contract";
import Sequence from "slotworks/utils/contracts/sequence";
import { Easing, Tween } from "slotworks/utils/tween";

export default class ZoomSymbolBehaviour extends AbstractSymbolBehaviour {

    public static PAUSE_DURATION: number = 500;
    public static ANIMATION_DURATION: number = 800;

    public static ZOOM_TO: number = 1.4;
    public static RESET_TO: number = 1;

    public behaviourName: string = "Zoom";

    private sprite: PIXI.Sprite;
    private activeTween: Tween;
    private originalScale: number;

    private contract: Contract<void>;

    public static() {
        super.static();
        this.symbol.setVisible(true);

        if (this.contract) {
            this.contract.cancel();
        }

        if (this.activeTween) {
            this.activeTween.stop();
        }

        if (this.sprite) {
            this.sprite.destroy();
            this.sprite = null;
        }
    }

    public win(): Contract<void> {

        this.symbol.setVisible(false);
        this.sprite = this.createStatic();

        this.contract = new Sequence([
            () => this.zoomTo(ZoomSymbolBehaviour.ZOOM_TO),
            () => Contract.getTimeoutContract(ZoomSymbolBehaviour.PAUSE_DURATION),
            () => this.zoomTo(ZoomSymbolBehaviour.RESET_TO)
        ]);

        return this.contract;
    }

    private zoomTo(targetScale: number) {
        return new Contract<void>((resolve) => {

            targetScale *= this.originalScale;

            const tween = new Tween(this.sprite.scale);
            tween.to({ x: targetScale, y: targetScale }, ZoomSymbolBehaviour.ANIMATION_DURATION);
            tween.easing(Easing.Sinusoidal.Out);
            tween.onComplete(() => resolve(null));
            tween.start();

            this.activeTween = tween;
        });
    }

    private createStatic() {

        if (this.sprite) {
            this.sprite.destroy();
        }

        const sprite = this.symbol.createStaticCopy();
        this.animationLayer.add(sprite);

        this.originalScale = sprite.scale.x;

        return sprite;
    }
}
